var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelVimeoFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#1AB7EA",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M7.406 10.915s.838-.662 1.117-.331c.28.33 1.345 4.328 1.7 5.065.311.647 1.168 1.502 2.107.892.94-.611 4.061-3.284 4.62-6.44s-3.757-2.495-4.214.254c1.143-.688 1.752.28 1.168 1.375s-1.117 1.807-1.396 1.807-.493-.732-.813-2.012c-.33-1.323-.328-3.706-1.7-3.436C8.701 8.344 7 10.381 7 10.381z"
}))));
export default SvgGemChannelVimeoFilled;